<template>
  <div class="content3">
    <div class="content4">
      <span class="title">预置应用信息公示查询</span>
    </div>
    <div style="display:flex; justify-content:center">
      <div style="marign-top:100px; text-align:left; max-width:1250px">
        <p class="content"
           style="margin-top:50px">声明：</p><br>
        <p class="content">智能终端预置应用是指由生产企业自行或与互联网信息服务提供者合作在智能终端出厂前安装在其系统中的应用程序（英文简称为“APP”）。</p><br>
        <p class="content">

          1.预置应用信息公示查询范围为2017年7月1日后入网的智能终端；
        </p>
        <br>
        <p class="content">
          2.公示中的预置应用对应出厂设置版本。如果系统升级、设备被 Root，预置应用可能会有变化；
        </p>
        <br>
        <p class="content">
          3.第三方应用由第三方公司开发、运营，在法律允许的范围内，不承担该应用任何方面的责任；

        </p>
        <br>
        <p class="content">
          4.公示中支持卸载的预置应用，可通过“系统设置 > 应用管理”或者在主屏幕长按应用图标进行卸载；

        </p>
        <br>

        <p class="content">
          5.对于公示范围内的智能终端，在主屏幕，打开“服务”应用，也可查看预置应用信息；

        </p>
        <br>

      </div>
    </div>

    <div class="content2">
      <div style="display:flex; max-width:1250px">
        <div style="flex-shrink:0; margin-top:5px">
          <span class="content"
                style="flex-shrink:0">预置应用查询：</span>
        </div>

        <div style="">
          <div style="position:relative;max-width:1200px"
               id="input">
            <input type="text"
                   placeholder="请输入机型"
                   style='margin-bottom:10px; max-width:920px;border-color:black'
                   @click="isShow = true"
                   v-model="selectPhone">
            <!-- <i class="el-icon-search" style="font-size:30px; position:absolute; right:20px;top:20px; "></i> -->
          </div>

          <br>
          <div style="text-align:left; margin-top:10px; margin-left:5vw">
            <span>* 产品型号查看方式：手机的设置菜单-系统-关于手机-型号，输入时请注意区分字母、数字和符号。</span>
          </div>

          <div style="margin-top:60px; font-size:18px"
               class="show"
               v-show="isShow">
            <div v-for="phone in phoneList"
                 :key="phone"
                 class="phone">
              <span class="phone"
                    v-if="phone.name == 'NZONE S7 Pro 5G'"
                    @click="isShow=false; show2 = true; show3 = false; selectPhone = phone.name">{{phone.name}}</span>
              <span class="phone"
                    v-else
                    @click="isShow=false; show2 = false; show3 = true; selectPhone = phone.name">{{phone.name}}</span>

            </div>

          </div>

          <div class="show"
               v-show="show2">

            <span class="content1"
                  @click="setitem(category1,'SP200 11.0.1.103(C07E8R1P3) 预置应用信息公示查询');$router.push({name: 'messageTable'}); window.scrollTo(0, 0)"
                  style="cursor:pointer">
              SP200 11.0.1.103(C07E8R1P3) 预置应用软件信息公示

            </span><br><br>

          </div>

          <div class="show"
               v-show="show3">

            <span class="content1"
                  @click="setitem(category2,'SP300 11.0.1.103(C07E8R1P3) 预置应用信息公示查询');$router.push({name: 'messageTable'}); window.scrollTo(0, 0)"
                  style="cursor:pointer">
              SP300 11.0.1.103(C07E8R1P3) 预置应用软件信息公示

            </span><br><br>

          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import { defineComponent } from 'vue'
import * as api from '../api/apt'

export default defineComponent({

  data () {
    return {
      isShow: false,
      show2: false,
      show3: false,
      productId: '1',
      category1: '',
      category2: '',
      selectPhone: '',
      phoneList: [
        {
          'name': 'NZONE S7 Pro 5G',

        },
        {
          'name': 'NZONE S7 Pro+ 5G'
        }]
    }
  },

  methods: {
    getPresetList () {
      api.getPresetList().then((res) => {
        this.category1 = res.data.result.results[0].category

        this.category2 = res.data.result.results[1].category

        console.log(res)


      })
    },
    setitem (category, title) {
      sessionStorage.setItem('category', category)
      sessionStorage.setItem('title', title)
    }

  },



  mounted () {

    this.getPresetList()


  }

})
</script>

<style scoped>
.title {
  font-size: 48px;
  font-style: SourceHanSansSC;
  color: #010101;
  font-weight: bold;
  letter-spacing: 2px;
}

.content {
  font-size: 16px;
  font-style: SourceHanSansSC-regular;
  color: black;
  letter-spacing: 1px;
}

.content1 {
  font-size: 16px;
  font-style: SourceHanSansSC-bold;
  color: #101010;
  font-weight: bold;
}

input {
  border: 2px solid #b8b8b8;
  width: 65vw;
  font-size: 18px;
  margin-left: 5vw;
  padding: 0.5vw 0 0.5vw 2vw;
  height: 30px;
}

.content2 {
  display: flex;
  margin-top: 50px;
  flex-shrink: 0;
  justify-content: center;
}

.show {
  margin-left: 5vw;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: left;
}

.content3 {
  margin-top: 150px;
  width: 100%;
  text-align: center;
}

.content4 {
  text-align: center;
  flex-shrink: 0;
}

.phone {
  font-size: 24px;
  cursor: pointer;
  margin-top: 20px;
}

.phone :hover {
  font-size: 24px;
  cursor: pointer;
  color: red;
}

.phone :active {
  font-size: 24px;
  cursor: pointer;
  color: red;
}
</style>
